// Added for cart upsell module on 23/04/26 — safe to delete this entire file if removing the module
(function () {

  const UPSELL_STORAGE_KEY = 'cartUpsellClosed';

  // Detect locale prefix from URL — returns '/en' or ''
  function getLocalePrefix() {
    const match = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    return match ? '/' + match[1] : '';
  }

  function isUpsellClosed() {
    try {
      return sessionStorage.getItem(UPSELL_STORAGE_KEY) === 'true';
    } catch (e) {
      return false; // sessionStorage unavailable (e.g. privacy mode) — fail open
    }
  }

  function closeUpsell(panel) {
    try {
      sessionStorage.setItem(UPSELL_STORAGE_KEY, 'true');
    } catch (e) {
      // ignore if sessionStorage unavailable
    }
    if (panel) panel.style.display = 'none';
  }

  function applyClosedState(root) {
    if (!isUpsellClosed()) return;
    root.querySelectorAll('.cart-upsell').forEach(panel => {
      panel.style.display = 'none';
    });
  }

  async function handleUpsellClick(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const btn = e.currentTarget;
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    const originalText = btn.textContent.trim();
    btn.classList.add('is-loading');
    btn.textContent = '...';

    try {
      const res = await fetch(getLocalePrefix() + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Add failed');

      const sectionsRes = await fetch(getLocalePrefix() + '/cart?sections=cart-drawer');
      const sections = await sectionsRes.json();

      if (sections['cart-drawer']) {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const currentDrawer = document.querySelector('cart-drawer');

        const newInner = newDoc.querySelector('#CartDrawer');
        const currentInner = currentDrawer.querySelector('#CartDrawer');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }

        currentDrawer.classList.remove('is-empty');

        const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          overlay.addEventListener('click', () => currentDrawer.close());
        }

        // Re-attach listeners to any new upsell buttons after drawer re-render
        attachListeners(currentDrawer);
      }

      fetch(getLocalePrefix() + '/cart?sections=cart-icon-bubble')
        .then(r => r.json())
        .then(sections => {
          if (sections['cart-icon-bubble']) {
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
            const newBubble = newDoc.querySelector('.cart-count-bubble');
            const currentBubble = document.querySelector('.cart-count-bubble');
            if (newBubble && currentBubble) {
              currentBubble.outerHTML = newBubble.outerHTML;
            } else if (newBubble && !currentBubble) {
              const cartLink = document.querySelector('a[href*="/cart"]');
              if (cartLink) cartLink.appendChild(newBubble);
            }
          }
        });

      btn.textContent = '✓ Added!';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.classList.remove('is-loading');
      }, 2000);

    } catch (err) {
      console.error('Cart upsell error:', err);
      btn.textContent = 'Error';
      btn.classList.remove('is-loading');
      setTimeout(() => { btn.textContent = originalText; }, 2000);
    }
  }

  function attachListeners(root) {
    // Hide the upsell immediately if it was closed earlier this session —
    // must run before anything else, since re-renders create fresh nodes.
    applyClosedState(root);

    root.querySelectorAll('.cart-upsell__btn').forEach(btn => {
      btn.removeEventListener('click', handleUpsellClick, true);
      btn.addEventListener('click', handleUpsellClick, true);
    });
    root.querySelectorAll('.cart-upsell__close').forEach(btn => {
      btn.removeEventListener('click', handleUpsellCloseClick);
      btn.addEventListener('click', handleUpsellCloseClick);
    });
  }

  function handleUpsellCloseClick(e) {
    const panel = e.currentTarget.closest('.cart-upsell');
    closeUpsell(panel);
  }

  attachListeners(document);

  const observer = new MutationObserver(() => {
    attachListeners(document);
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();